import Maya from "public/images/jpg/niamh.jpg"
import Anshuman from "public/images/webp/anshuman.webp"

export const markdownExample = {
  notes: `#### Notes
  
  ##### Table of Contents
  1. [Introduction](#introduction)
  2. [Main Content](#main-content)
  3. [List Example](#list-example)
  4. [Link and Emphasis](#link-and-emphasis)
  5. [Table Example](#table-example)
  
  ##### Introduction
  
  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla quam velit, vulputate eu pharetra nec, mattis ac neque.
  
  ##### Main Content
  
  Duis vulputate commodo lectus, ac blandit elit tincidunt id. Sed rhoncus, tortor sed eleifend tristique, tortor mauris molestie elit, et luctus enim justo non.
  
  This is a **bold text** and this is an *italicized text*.
  
  ## List Example
  
  Here's an unordered list:
  - Item 1
  - Item 2
  - Item 3
  
  And an ordered list:
  1. First item
  2. Second item
  3. Third item
  
  ## Link and Emphasis
  
  Visit [OpenAI](https://www.openai.com) for more information on AI.
  
  Here's a sentence with a \`code inline\` element.
  
  ## Table Example
  
  | Column 1 | Column 2 | Column 3 |
  |----------|----------|----------|
  | Row 1, Col 1 | Row 1, Col 2 | Row 1, Col 3 |
  | Row 2, Col 1 | Row 2, Col 2 | Row 2, Col 3 |
  
  ---
  
  > This is a blockquote. It can be used to highlight important information.
  
  Finally, here's a code block:
  
  \`\`\`python
  def hello_world():
      print("Hello, World!")
  \`\`\`
    `,
}

export const reviewExample = [{}]

export const DEVELOPMENT_WS_BASE_URL = "ws://localhost:8000"
export const STAGING_WS_BASE_URL =
  process.env.NEXT_PUBLIC_API_URL?.replace(/^http/, "ws") || "wss://staging.companion.scaler.com"
export const PRODUCTION_WS_BASE_URL = "wss://api.companion.scaler.com"

export const results = [
  {
    content: "🔥 9.5 / 10",
    value: "Overall Score",
  },
  {
    content: "⏰ 48 min",
    value: "Time Taken",
  },
]

export const resultTips = [
  {
    title: "Quick Tips",
    tips: [
      "Sit vel sunt molestiae suscipit dolore.",
      "Quisquam ut voluptatem.",
      "Qui fugiat est aut voluptatum dolor voluptatibus.",
      "Sint voluptatem rerum quo possimus recusandae voluptates quae. ",
      "Eaque aperiam voluptates quam.",
      "Ad dolor enim enim eaque.",
    ],
  },
  {
    title: "Quick Tips",
    tips: [
      "Sit vel sunt molestiae suscipit dolore.",
      "Quisquam ut voluptatem.",
      "Qui fugiat est aut voluptatum dolor voluptatibus.",
      "Sint voluptatem rerum quo possimus recusandae voluptates quae. ",
      "Eaque aperiam voluptates quam.",
      "Ad dolor enim enim eaque.",
    ],
  },
  {
    title: "Quick Tips",
    tips: [
      "Sit vel sunt molestiae suscipit dolore.",
      "Quisquam ut voluptatem.",
      "Qui fugiat est aut voluptatum dolor voluptatibus.",
      "Sint voluptatem rerum quo possimus recusandae voluptates quae. ",
      "Eaque aperiam voluptates quam.",
      "Ad dolor enim enim eaque.",
    ],
  },
]

export const EXCALIDRAW_LS_KEY = "excalidraw-data"
export const CODE_EDITOR_LS_KEY = "companion/code-editor"

export const BEHAVIORAL_STAGE = {
  FORM: "form",
  INTERVIEW: "interview",
  REVIEW: "review",
  CONTINUE: "continue",
}

export const REPORT_ISSUE = {
  placeholder: "Please describe the issue you are facing",
  submit: "Submit",
  errorText: "There was an error while reporting the issue. Please try again later.",
  onSuccess: "Your issue has been successfully reported !",
  title: "Report Companion Issue",
}

export const FEEDBACK_URL = "https://interviewbit.typeform.com/to/KU3ATipW"

export const IST_OFFSET = 5.5 * 60 * 60 * 1000

export const ENABLED_CODE_LANG_TYPES = {
  javascript: "javascript",
  javascript_sst: "javascript",
  "c++:": "cpp",
  python: "python",
  python_basics: "python",
  java: "java",
  c: "c",
  csharp: "csharp",
  go: "go",
  kotlin: "kotlin",
  rust: "rust",
  ruby: "ruby",
  swift: "swift",
  php: "php",
  spring_boot: "java",
  react: "javascript",
  mern: "javascript",
  django: "python",
  nlp: "python",
  computer_vision: "python",
  unsupervised_learning: "python",
  supervised_learning: "python",
  eda: "python",
  angular: "javascript",
  devops_linux_cs_fundamentals: "bash",
  ims_ai_personal_interview_ssb_internal_testing: "text",
  deepgram_streaming_testing: "text",
}

// Socket Constants --------

export const SOCKET_RECONNECT_DELAY = 2000
export const SOCKET_MAX_RECONNECT_ATTEMPTS = 4000

// Socket Manager Constants --------
export const SOCKET_MANAGER_PONG_FAIL_COUNT = 4
export const SOCKET_MANAGER_PONG_INTERVAL_TIME = 3000
export const SOCKET_MANAGER_COMMON_DELAY = 1000
export const SOCKET_MANAGER_EACH_CHUNK_TIMEOUT = 30000

// Network Speed Test Constants --------
export const NETWORK_DOWNLOAD_SPEED = 5
export const NETWORK_UPLOAD_SPEED = 1

// Websocket Manager Name Mapping
export const WEBSOCKET_MANAGER_BOT_RESPONSE_NAME_MAPPING = {
  dsa: "dsa",
  lld: "lld",
  sql: "sql",
  dsmlSql: "dsml-sql",
  interview: "interview",
  language: "language",
}

// Interrupt status for messages
export const MESSAGE_TYPES_INTERRUPTION_STATUS = {
  start: false,
  next_question: false,
  end_interview: false,
  candidate_response: true,
}

// Courses constants Below
export const COURSE_ID_INTERVIEWER_NAME_MAPPING = {
  1: "Anshuman",
  2: "Anshuman",
  3: "Maya",
  4: "Maya",
}

// Courses constants Below
export const INTERVIEWER_SLUG_INTERVIEWER_NAME_MAPPING = {
  analysis_of_income_statement: "Maya",
  finding_effective_tax_rate: "Maya",
  calculate_income_tax: "Maya",
  find_carrying_amount: "Maya",
  talk_to_teaching_assistant: "Maya",
  dsa: "Anshuman",
}

export const INTERVIEWER_NAME_DETAIL_MAPPING = {
  Anshuman: {
    image: Anshuman,
    name: "Anshuman Singh",
  },
  Maya: {
    image: Maya,
    name: "Maya",
  },
}
